import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import Shape from '@bubble-ui/primitive-shape';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
var getFlagBorderStylesheet = _ref => {
  var {
    designContext
  } = _ref;
  var borderColor = designContext.get('colors/borders/default');
  return {
    strokeStyles: {
      fill: 'none',
      strokeWidth: 0.278,
      stroke: borderColor.withAlpha(0.1).toString()
    }
  };
};
var FlagBorder = () => {
  var designContext = useDesignContext(defaultColorVariables);
  var {
    strokeStyles
  } = getFlagBorderStylesheet({
    designContext
  });
  return /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M0.5,25a24.5,24.5 0 1,0 49,0a24.5,24.5 0 1,0 -49,0",
    vectorEffect: "non-scaling-stroke"
  }, strokeStyles));
};
FlagBorder.displayName = 'FlagBorder';
export default withProvisionalOverrideFromContext(FlagBorder);
//# sourceMappingURL=index.js.map